module.exports = __webpack_public_path__ + "img/feature_c04.0d086f69.svg";